import React from 'react';
import { sectionedPanelStyle } from '../../../../styles';
import { Spacer } from '@adserve/adserve-react-components';
import { formatNumber } from 'devextreme/localization';
const OverAllPerformance = (data) => {
    const numberFormat = (v, p) => {
        return formatNumber(parseFloat(v).toFixed(p));
    };
    return (
        <>
            <table
                border={1}
                style={{
                    borderCollapse: 'collapse',
                    fontSize: 13,
                    fontWeight: 500,
                    color: 'rgb(65,65,65)',
                    width: '100%',
                    height: 280
                }}
            >
                <thead>
                    <tr style={{ height: 35 }}>
                        <th></th>
                        <th>{window.translate('Booked')}</th>
                        <th>{window.translate('Delivered')}</th>
                        <th>{window.translate('Scheduled')}</th>
                        <th>{window.translate('Tracking')}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{window.translate('Impacts')}</td>
                        <td style={{ textAlign: 'center', backgroundColor: 'rgba(216,216,216,0.2)' }}>
                            {numberFormat(data?.data.bookedImpacts, 0)}
                        </td>
                        <td style={{ textAlign: 'center', backgroundColor: 'rgba(216,216,216,0.2)' }}>
                            {numberFormat(data?.data.deliveredImpacts, 0)}
                        </td>
                        <td style={{ textAlign: 'center', backgroundColor: 'rgba(216,216,216,0.2)' }}>
                            {numberFormat(data?.data.scheduledImpacts, 0)}
                        </td>
                        <td style={{ textAlign: 'center', backgroundColor: 'rgba(216,216,216,0.2)' }}>
                            {numberFormat((data?.data.scheduledImpacts / data?.data.bookedImpacts) * 100, 0)} %
                        </td>
                    </tr>
                    <tr>
                        <td>{window.translate('Spots')}</td>
                        <td style={{ textAlign: 'center' }}>{numberFormat(data?.data.bookedSpots, 0)}</td>
                        <td style={{ textAlign: 'center' }}>{numberFormat(data?.data.deliveredSpots, 0)}</td>
                        <td style={{ textAlign: 'center' }}>{numberFormat(data?.data.scheduledSpots, 0)}</td>
                        <td style={{ textAlign: 'center' }}>
                            {numberFormat((data?.data.scheduledSpots / data?.data.bookedSpots) * 100, 0)}%
                        </td>
                    </tr>
                    <tr>
                        <td>{window.translate('Reach')}</td>
                        <td style={{ textAlign: 'center', backgroundColor: 'rgba(216,216,216,0.2)' }}>
                            {numberFormat(data?.data.bookedReach, 0)}
                        </td>
                        <td style={{ textAlign: 'center', backgroundColor: 'rgba(216,216,216,0.2)' }}>
                            {numberFormat(data?.data.deliveredReach, 0)}
                        </td>
                        <td style={{ textAlign: 'center', backgroundColor: 'rgba(216,216,216,0.2)' }}>
                            {numberFormat(data?.data.scheduledReach, 0)}
                        </td>
                        <td style={{ textAlign: 'center', backgroundColor: 'rgba(216,216,216,0.2)' }}>
                            {numberFormat((data?.data.scheduledReach / data?.data.bookedReach) * 100, 0)}%
                        </td>
                    </tr>
                    <tr>
                        <td>{window.translate('OTH')}</td>
                        <td style={{ textAlign: 'center' }}>{numberFormat(data?.data.bookedOTH, 1)}</td>
                        <td style={{ textAlign: 'center' }}>{numberFormat(data?.data.deliveredOTH, 1)}</td>
                        <td style={{ textAlign: 'center' }}>{numberFormat(data?.data.scheduledOTH, 1)}</td>
                        <td style={{ textAlign: 'center' }}>
                            {numberFormat((data?.data.scheduledOTH / data?.data.bookedOTH) * 100, 0)} %
                        </td>
                    </tr>
                    <tr>
                        <td>{window.translate('Reach %')}</td>
                        <td style={{ textAlign: 'center', backgroundColor: 'rgba(216,216,216,0.2)' }}>
                            {numberFormat(data?.data.bookedReachPct, 1)}
                        </td>
                        <td style={{ textAlign: 'center', backgroundColor: 'rgba(216,216,216,0.2)' }}>
                            {numberFormat(data?.data.deliveredReachPct, 1)}
                        </td>
                        <td style={{ textAlign: 'center', backgroundColor: 'rgba(216,216,216,0.2)' }}>
                            {numberFormat(data?.data.scheduledReachPct, 1)}
                        </td>
                        <td style={{ textAlign: 'center', backgroundColor: 'rgba(216,216,216,0.2)' }}>
                            {numberFormat((data?.data.scheduledReachPct / data?.data.bookedReachPct) * 100, 0)}%
                        </td>
                    </tr>
                    <tr>
                        <td>{window.translate('Weekly OTH')}</td>
                        <td style={{ textAlign: 'center' }}>{numberFormat(data?.data.bookedWeeklyOTH, 1)}</td>
                        <td style={{ textAlign: 'center' }}>{numberFormat(data?.data.deliveredWeeklyOTH, 1)}</td>
                        <td style={{ textAlign: 'center' }}>{numberFormat(data?.data.scheduledWeeklyOTH, 1)}</td>
                        <td style={{ textAlign: 'center' }}>
                            {numberFormat((data?.data.scheduledWeeklyOTH / data?.data.bookedWeeklyOTH) * 100, 0)} %
                        </td>
                    </tr>
                    <tr>
                        <td>{window.translate('Budget')}</td>
                        <td style={{ textAlign: 'center', backgroundColor: 'rgba(216,216,216,0.2)' }}>
                            {numberFormat(data?.data.bookedBudget)}
                        </td>
                        <td style={{ textAlign: 'center', backgroundColor: 'rgba(216,216,216,0.2)' }}>
                            {numberFormat(data?.data.deliveredBudget, 0)}
                        </td>
                        <td style={{ textAlign: 'center', backgroundColor: 'rgba(216,216,216,0.2)' }}>
                            {numberFormat(data?.data.scheduledBudget, 0)}
                        </td>
                        <td style={{ textAlign: 'center', backgroundColor: 'rgba(216,216,216,0.2)' }}>
                            {numberFormat((data?.data.scheduledBudget / data?.data.bookedBudget) * 100, 0)} %
                        </td>
                    </tr>
                </tbody>
            </table>
        </>
    );
};
export default OverAllPerformance;
